import "./App.css";

import { Route, Routes } from "react-router-dom";
import Protected from "./functions/Protected";
import Dashboard from "./admin/Dashboard";

import Login from "./admin/Login";


export default function App() {
  return (
    <Routes   basename="/">
      <Route path="/" element={<Login />} />    
        <Route path="/app/*" element={<Protected Components={Dashboard}/>} />
    </Routes>
  );
}
